var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWeNeedYourHelpBack(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "none",
    width: 8216.641,
    height: 6169.914,
    viewBox: "0 0 8216.641 6169.914",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_4221",
    "data-name": "Path 4221",
    d: "M665.918,394.615C335.439,573.539,89.912,895.324,59.929,1247.582,16.51,1760.127,406.177,2214.521,821.5,2556.9s894.046,651.3,1136.13,1114.179c265.627,508.91,174.9,1158.724-222.1,1589.075-170.792,185.261-408.657,372.76-376.341,614.309,30.2,225.333,303.716,365.956,549.576,355.427s468.511-129.721,683.167-240.8c769.562-398.387,1608.2-739.649,2490.581-746.079,946.017-6.8,2333.337,262.8,3190.737,631.456,0-1160.55,0-5271.278,0-5813.934C7668.93,144.4,7114.577,407.941,6540.906,601.03c-1025.416,344.8-2171.43,464.459-3210.616,156.093C2493.766,509.238,1531.2-73.758,665.918,394.615Z",
    transform: "translate(-56.611 -60.529)",
    fill: "#0e7f8a",
    opacity: 0.1
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWeNeedYourHelpBack);
export default __webpack_public_path__ + "static/media/WeNeedYourHelpBack.aa5e6744871e753c9c1377642b4f37d1.svg";
export { ForwardRef as ReactComponent };